<template>
    <div class="points-patch" :class="'points--' + type">
        <aha-patch-svg class="points--bg"/>

        <div class="points--amount text-center white--text">
            <quest-calculated-points
                class="text-h3 font-weight-bold"
                :start-date="startDate"
                :end-date="endDate"
                :rhythm-repeat="rhythmRepeat"
                :is-responsible="quest.isResponsible"
                :quest="quest"
            />

            <p class="mb-0 font-weight-bold text-uppercase">{{$t('points')}}</p>
        </div>
    </div>
</template>

<style>
.points--basic .points--bg path.cls-1 {
    fill: var(--v-basic-lighten2);
}
.points--basic .points--bg path.cls-2 {
    fill: var(--v-basic-lighten1);
}
.points--basic .points--bg path.cls-3 {
    fill: var(--v-basic-base);
}
.points--periodic .points--bg path.cls-1 {
    fill: var(--v-periodic-lighten2);
}
.points--periodic .points--bg path.cls-2 {
    fill: var(--v-periodic-lighten1);
}
.points--periodic .points--bg path.cls-3 {
    fill: var(--v-periodic-base);
}
.points--online .points--bg path.cls-1 {
    fill: var(--v-online-lighten2);
}
.points--online .points--bg path.cls-2 {
    fill: var(--v-online-lighten1);
}
.points--online .points--bg path.cls-3 {
    fill: var(--v-online-base);
}
</style>

<style scoped>
.points-patch {
    position: relative;
}
.points--amount {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>

<script>
import AhaPatchSvg from './AhaPatchSvg';

export default {
    components: {
        AhaPatchSvg,
    },
    props: {
        type: {},
        startDate: {},
        endDate: {},
        startTime: {},
        endTime: {},
        rhythmRepeat: {},
        quest: {},
    },
};
</script>